import { autoinject } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { MobileHelper } from "../../../../../../helpers/mobile-helper";
import { DialogServiceConstants } from "../../../../../../constants/basics/dialog.constants";

@autoinject
export class DefaultMasterPage {

    model: any;
    public isMobile = MobileHelper.isMobileDevice();
    constructor(private dialogClientService: DialogClientService) { }

    activate(model: any) {
        this.model = model;
    }

    continueFromMobile() {
        this.dialogClientService.show(DialogServiceConstants.URLs.ContinueFromMobileDialog, {}, false);
    }
}
